import React, {memo} from 'react';
import {AMBIT_MESSAGE_CONTENT_TYPE, Message} from './types';
import {MessageBubble} from './styles';
import TextWithLinkDetection from './TextWithLinkDetection';
import MessageCardHero from './MessageCardHero';
import useMediaQuery from '../hooks/useMediaQuery';
import {Variants} from 'framer-motion';

type MessageElementProps = {
  message: Message;
};

const variants: Variants = {
  hidden: {opacity: 0, y: 24},
  show: {
    opacity: 1,
    y: 0,
  },
};

const MessageElement: React.FC<MessageElementProps> = ({message}) => {
  const {isMobile} = useMediaQuery();

  if (message.contentType === AMBIT_MESSAGE_CONTENT_TYPE.CARD_HERO) {
    return (
      <>
        {message.attachments.map((attachment) => (
          <MessageCardHero
            key={attachment.title}
            href={attachment.href}
            imageUrl={attachment.imageUrl}
            title={attachment.title}
            text={attachment.text}
            isNewBlock={message.isNewBlock}
          />
        ))}
      </>
    );
  }

  return (
    <MessageBubble
      variants={variants}
      initial="hidden"
      animate="show"
      isUser={message.isUser}
      isMobile={isMobile}
      isNewBlock={message.isNewBlock}
    >
      <TextWithLinkDetection text={message.text || ''} />
    </MessageBubble>
  );
};

export default memo(MessageElement);
